import { render } from "./tenantList.vue?vue&type=template&id=3460d81c&scoped=true"
import script from "./tenantList.vue?vue&type=script&lang=js"
export * from "./tenantList.vue?vue&type=script&lang=js"

import "./tenantList.vue?vue&type=style&index=0&id=3460d81c&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3460d81c"]])

export default __exports__